import { isDebugMode } from './environment';

const isDebug = isDebugMode();

export const logger = {
    log: (message: string, ...args: any[]) => {
        if (isDebug) console.log(message, ...args);
    },
    info: (message: string, ...args: any[]) => {
        if (isDebug) console.info(`%c[INFO] ${message}`, "color: #36688d; font-weight: bold;", ...args);
    },
    warn: (message: string, ...args: any[]) => {
        if (isDebug) console.warn(message, ...args);
    },
    error: (message: string, ...args: any[]) => {
        console.error(`[GM-ERROR] ${message}`, ...args);
    },
    banner: (version: string) => {
        if (isDebug) {
            console.log(`%c[GM-WEB] SCRIPT LOADED: ${version}`, "color: white; background: #36688d; padding: 4px 8px; border-radius: 4px; font-weight: bold;");
        }
    }
};
